(() => {
  (() => {
    const interval = setInterval(() => {
      console.log('sort');
      let el = document.querySelector('select.jm-sort-filter__select');    
      if (el) {
        // setTimeout(()=>{
          // el = document.querySelector('select.jm-sort-filter__select');
          el.value = 'pictures_first';
          el.dispatchEvent(new Event('change', { bubbles: true }));
        // }, 2000);
        // clearInterval(interval); // Stops the loop once found and updated
      }
    }, 1000); // Checks every 100 milliseconds

  })();

  const COLOR_MAP = {
    Black: "#111111",
    Purple: "#7e53af",
    Red: "#e94244",
    Blue: "#4e69e4"
  };

  const STYLE_ID = "qb-button-radio-style";
  const SELECT_SELECTOR = "select.quantity-break__variant-select";
  const TIER_SELECTOR = "label.quantity-break";

  const tierSyncTokens = new WeakMap();
  let enhanceQueued = false;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      .qb-hidden-select {
        display: none !important;
      }

      .qb-button-radio-group {
        display: inline-flex;
        align-items: stretch;
        border: 1px solid #dedbe5;
        border-radius: 10px;
        overflow: hidden;
        background: #fff;
        min-height: 42px;
        margin-top: 4px;
      }

      .qb-button-radio {
        appearance: none;
        -webkit-appearance: none;
        width: 58px;
        min-height: 42px;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: 0;
        border-right: 1px solid #ebe8f0;
        background: #fff;
        transition:
          background 120ms ease,
          box-shadow 120ms ease;
        border-radius: 10px;
        position: relative;
      }

      .qb-button-radio:last-child {
        border-right: 0;
      }

      .qb-button-radio::before {
        content: "";
        width: 24px;
        height: 24px;
        border-radius: 999px;
        background: var(--qb-colour);
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
      }

      .qb-button-radio[data-colour="Black"]::before {
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.25);
      }

      .qb-button-radio[aria-checked="true"] {
        background: #fff;
        box-shadow: inset 0 0 0 2px #1f1235;
        z-index: 1;
      }

      .qb-button-radio[aria-checked="true"]::before {
        transform: scale(1.05);
      }

      .qb-button-radio:hover {
        background: #faf9fc;
      }

      .qb-button-radio:focus-visible {
        outline: 2px solid #1f1235;
        outline-offset: -4px;
      }
    `;

    document.head.appendChild(style);
  }

  function normalise(value) {
    return String(value ?? "").trim();
  }

  function getTierSelects(quantityBreak) {
    return [
      ...quantityBreak.querySelectorAll(SELECT_SELECTOR)
    ];
  }

  function getStoredSelections(quantityBreak) {
    try {
      const parsed = JSON.parse(
        quantityBreak.dataset.qbSelections || "[]"
      );

      return Array.isArray(parsed)
        ? parsed.map(normalise)
        : [];
    } catch {
      return [];
    }
  }

  function storeSelections(quantityBreak, values) {
    quantityBreak.dataset.qbSelections = JSON.stringify(
      values.map(normalise)
    );
  }

  function optionExists(select, value) {
    const wanted = normalise(value);

    return [...select.options].some(
      option => normalise(option.value) === wanted
    );
  }

  function getExactOptionValue(select, value) {
    const wanted = normalise(value);

    const option = [...select.options].find(
      candidate => normalise(candidate.value) === wanted
    );

    return option ? option.value : null;
  }

  function initialiseTierState(quantityBreak) {
    const selects = getTierSelects(quantityBreak);
    if (!selects.length) return;

    const stored = getStoredSelections(quantityBreak);

    const storedIsValid =
      stored.length === selects.length &&
      stored.every((value, index) => {
        return optionExists(selects[index], value);
      });

    if (storedIsValid) return;

    const firstOptions = [...selects[0].options].map(
      option => normalise(option.value)
    );

    const allSelectsHaveSameOptions = selects.every(select => {
      const values = [...select.options].map(
        option => normalise(option.value)
      );

      return (
        values.length === firstOptions.length &&
        values.every(
          (value, index) => value === firstOptions[index]
        )
      );
    });

    const quantity = Number(quantityBreak.dataset.quantity);

    const shouldAutoPickOneOfEach =
      quantity > 0 &&
      allSelectsHaveSameOptions &&
      selects.length === quantity &&
      firstOptions.length >= quantity;

    const values = shouldAutoPickOneOfEach
      ? selects.map((_, index) => {
          return firstOptions[index % firstOptions.length];
        })
      : selects.map(select => normalise(select.value));

    storeSelections(quantityBreak, values);
  }

  function getDesiredValue(select) {
    const quantityBreak = select.closest(TIER_SELECTOR);

    if (!quantityBreak) {
      return normalise(select.value);
    }

    const selects = getTierSelects(quantityBreak);
    const index = selects.indexOf(select);
    const stored = getStoredSelections(quantityBreak);

    if (
      index >= 0 &&
      optionExists(select, stored[index])
    ) {
      return stored[index];
    }

    return normalise(select.value);
  }

  function saveDesiredValue(select, value) {
    const quantityBreak = select.closest(TIER_SELECTOR);
    if (!quantityBreak) return;

    const selects = getTierSelects(quantityBreak);
    const index = selects.indexOf(select);

    if (index < 0) return;

    const stored = getStoredSelections(quantityBreak);

    while (stored.length < selects.length) {
      stored.push(
        normalise(selects[stored.length].value)
      );
    }

    stored[index] = normalise(value);

    storeSelections(quantityBreak, stored);
  }

  function syncButtonGroup(select, value = select.value) {
    const groupId = select.dataset.qbGroupId;
    const group = groupId
      ? document.getElementById(groupId)
      : null;

    if (!group) return;

    const wanted = normalise(value);

    group
      .querySelectorAll(".qb-button-radio")
      .forEach(button => {
        const checked =
          normalise(button.dataset.value) === wanted;

        button.setAttribute(
          "aria-checked",
          checked ? "true" : "false"
        );
      });
  }

  function updateSelectorItem(select, value) {
    const selectorItem = select.closest(
      ".quantity-break__selector-item"
    );

    if (selectorItem) {
      selectorItem.dataset.selectedValue =
        normalise(value);
    }
  }

  function fireSelectEvents(select) {
    select.dataset.qbDispatching = "true";

    select.dispatchEvent(
      new Event("input", {
        bubbles: true
      })
    );

    select.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );

    select.dispatchEvent(
      new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          value: select.value,
          select
        }
      })
    );

    queueMicrotask(() => {
      delete select.dataset.qbDispatching;
    });
  }

  function applySelectValue(
    select,
    value,
    fireEvents = false
  ) {
    const exactValue = getExactOptionValue(
      select,
      value
    );

    if (exactValue === null) {
      return false;
    }

    const changed = select.value !== exactValue;

    /*
     * Only change the current DOM value.
     *
     * Do not manually add or remove selected="selected"
     * attributes. The theme may use those attributes as
     * defaults when cloning or resetting the selectors.
     */
    select.value = exactValue;

    updateSelectorItem(select, exactValue);
    syncButtonGroup(select, exactValue);

    if (fireEvents) {
      fireSelectEvents(select);
    }

    return changed;
  }

  function restoreTier(
    quantityBreak,
    fireEvents = true
  ) {
    if (!quantityBreak?.isConnected) return;

    initialiseTierState(quantityBreak);

    const selects = getTierSelects(quantityBreak);
    const stored = getStoredSelections(quantityBreak);

    /*
     * Restore every select first.
     *
     * Only after all values are restored do we dispatch
     * events. This stops the theme reading a partially
     * restored tier while processing the first event.
     */
    selects.forEach((select, index) => {
      applySelectValue(
        select,
        stored[index],
        false
      );
    });

    if (fireEvents) {
      selects.forEach(select => {
        fireSelectEvents(select);
      });
    }
  }

  function scheduleTierRestore(quantityBreak) {
    if (!quantityBreak) return;

    const token =
      (tierSyncTokens.get(quantityBreak) || 0) + 1;

    tierSyncTokens.set(quantityBreak, token);

    queueMicrotask(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (
            tierSyncTokens.get(quantityBreak) !== token
          ) {
            return;
          }

          restoreTier(quantityBreak, true);

          /*
           * Some Shopify themes update the variant selects
           * again shortly after the quantity tier changes.
           *
           * Check once more after that delayed update.
           */
          setTimeout(() => {
            if (
              tierSyncTokens.get(quantityBreak) !== token
            ) {
              return;
            }

            const isOutOfSync = getTierSelects(
              quantityBreak
            ).some(select => {
              return (
                normalise(select.value) !==
                getDesiredValue(select)
              );
            });

            if (isOutOfSync) {
              restoreTier(quantityBreak, true);
            } else {
              getTierSelects(
                quantityBreak
              ).forEach(select => {
                syncButtonGroup(
                  select,
                  select.value
                );

                updateSelectorItem(
                  select,
                  select.value
                );
              });
            }
          }, 60);
        });
      });
    });
  }

  function buildButtonGroup(select, index) {
    const group = document.createElement("div");

    group.className = "qb-button-radio-group";
    group.id =
      `qb-colour-group-${index}-` +
      Math.random().toString(36).slice(2);

    group.setAttribute("role", "radiogroup");
    group.setAttribute("aria-label", "Colour");

    select.dataset.qbGroupId = group.id;

    const desiredValue = getDesiredValue(select);

    [...select.options].forEach(option => {
      const value = normalise(option.value);

      const button =
        document.createElement("button");

      button.type = "button";
      button.className = "qb-button-radio";
      button.title = value;

      button.setAttribute("role", "radio");
      button.setAttribute("aria-label", value);

      button.setAttribute(
        "aria-checked",
        value === desiredValue
          ? "true"
          : "false"
      );

      button.dataset.colour = value;
      button.dataset.value = value;

      button.style.setProperty(
        "--qb-colour",
        COLOR_MAP[value] || "#cccccc"
      );

      /*
       * The whole quantity tier is already a <label>.
       *
       * These must be buttons rather than more labels.
       * Stopping propagation prevents a colour click from
       * also activating the outer quantity tier label.
       */
      button.addEventListener(
        "pointerdown",
        event => {
          event.stopPropagation();
        }
      );

      button.addEventListener("click", event => {
        event.preventDefault();
        event.stopPropagation();

        saveDesiredValue(select, value);

        applySelectValue(
          select,
          value,
          true
        );
      });

      group.appendChild(button);
    });

    return group;
  }

  function enhanceSelect(select, index) {
    if (
      select.dataset.qbButtonRadioInjected ===
      "true"
    ) {
      syncButtonGroup(
        select,
        getDesiredValue(select)
      );

      return false;
    }

    select.dataset.qbButtonRadioInjected = "true";

    const selectWrapper =
      select.closest(".select") ||
      select.parentElement;

    if (selectWrapper) {
      selectWrapper.classList.add(
        "qb-hidden-select"
      );
    } else {
      select.classList.add("qb-hidden-select");
    }

    const group = buildButtonGroup(
      select,
      index
    );

    const selectorItem = select.closest(
      ".quantity-break__selector-item"
    );

    if (selectorItem) {
      selectorItem.appendChild(group);
    } else if (selectWrapper) {
      selectWrapper.insertAdjacentElement(
        "afterend",
        group
      );
    } else {
      select.insertAdjacentElement(
        "afterend",
        group
      );
    }

    applySelectValue(
      select,
      getDesiredValue(select),
      false
    );

    return true;
  }

  function findTierForQuantityInput(input) {
    if (!input?.id) return null;

    const sibling = input.nextElementSibling;

    if (
      sibling?.matches(TIER_SELECTOR) &&
      sibling.htmlFor === input.id
    ) {
      return sibling;
    }

    return (
      [...document.querySelectorAll(
        TIER_SELECTOR
      )].find(label => {
        return label.htmlFor === input.id;
      }) || null
    );
  }

  function enhanceAll() {
    enhanceQueued = false;

    injectStyles();

    const tiers = [
      ...document.querySelectorAll(
        TIER_SELECTOR
      )
    ];

    tiers.forEach(quantityBreak => {
      initialiseTierState(quantityBreak);
    });

    document
      .querySelectorAll(SELECT_SELECTOR)
      .forEach((select, index) => {
        enhanceSelect(select, index);
      });

    document
      .querySelectorAll(
        'quantity-breaks input[name="quantity"]:checked'
      )
      .forEach(input => {
        const quantityBreak =
          findTierForQuantityInput(input);

        if (!quantityBreak) return;

        const isOutOfSync = getTierSelects(
          quantityBreak
        ).some(select => {
          return (
            normalise(select.value) !==
            getDesiredValue(select)
          );
        });

        if (
          quantityBreak.dataset
            .qbInitialSyncDone !== "true" ||
          isOutOfSync
        ) {
          quantityBreak.dataset.qbInitialSyncDone =
            "true";

          scheduleTierRestore(quantityBreak);
        }
      });
  }

  function queueEnhanceAll() {
    if (enhanceQueued) return;

    enhanceQueued = true;

    requestAnimationFrame(enhanceAll);
  }

  document.addEventListener(
    "change",
    event => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      if (
        target.matches(
          'quantity-breaks input[name="quantity"]'
        ) &&
        target.checked
      ) {
        scheduleTierRestore(
          findTierForQuantityInput(target)
        );

        return;
      }

      if (target.matches(SELECT_SELECTOR)) {
        const select = target;

        if (
          select.dataset.qbDispatching === "true"
        ) {
          return;
        }

        const quantityBreak =
          select.closest(TIER_SELECTOR);

        const desired =
          getDesiredValue(select);

        if (
          quantityBreak &&
          normalise(select.value) !== desired
        ) {
          /*
           * The theme changed the hidden select while
           * switching tiers. Restore the saved custom
           * value after the current event finishes.
           */
          scheduleTierRestore(quantityBreak);
        } else {
          syncButtonGroup(
            select,
            select.value
          );

          updateSelectorItem(
            select,
            select.value
          );
        }
      }
    }
  );

  enhanceAll();

  const observer = new MutationObserver(
    queueEnhanceAll
  );

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();